import React from "react";

// F-2 — page subtitle "<Agency name> · N members" (ARTBOARD-SPEC boards
// 1a/1l/2j title row; wave-2 follow-up). Data comes from the tab-counts
// response (name + member_count — same single fetch as the F-3 pills,
// per the wave-2 brief). Renders NOTHING until/unless that data exists
// (fail-silent contract: an errored counts request hides the subtitle).
// Desktop: 13px #64748B (board 1a). Mobile: 12.5px (board 1l).
const AgencySubtitle = ({ name, memberCount, mobile = false }) => {
  if (!name || memberCount == null) return null;
  return (
    <p
      className={`${mobile ? "text-[12.5px]" : "text-[13px]"} text-[#64748B] m-0`}
      data-testid="agency-subtitle"
    >
      <span data-no-translate>
        {name} · {memberCount}{" "}
      </span>
      {memberCount === 1 ? "member" : "members"}
    </p>
  );
};

export default AgencySubtitle;
